/*
 * @Author: your name
 * @Date: 2021-05-27 08:43:15
 * @LastEditTime: 2021-07-23 17:15:21
 * @LastEditors: sueRimn
 * @Description: In User Settings Edit
 * @FilePath: \app-project\src\i18n\language\en.js
 */
const en = {
  message: {
    privacyPolicy: 'App privacy policy',
    firstTitle: 'Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District.',
    secondTitle: '1、 Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District.',
    thirdTitle: '2、 Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai.',
    fourTitle: '3、 Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai Street office Nanshan District Aohai.',
    serviceTerms: 'serviceTerms',
    warehouseToday: 'Today inbound',
    stockToday: 'Today outbound',
    yesterdayEnterQuantity: 'Yesterday Inbound',
    yesterdayOutQuantity: 'Yesterday Outbound',
    deliveryInventory: 'Ship inventory',
    retentionQuantity: 'Remaining parcel',
    sevenDaySendQuantity: 'Order quantity in 7 days',
    sevenDayPickQuantity: 'Collection weight in 7 days',
    ENTER_QUANTITY: 'Inbound quantity',
    OUT_QUANTITY: 'Outbound quantity',
    SEND_QUANTITY: 'Shipment order quantity',
    PICK_WEIGHT: 'Shipping weight',
    SEVEN: 'Last 7 days',
    THIS_MONTH: 'This month',
    LAST_MONTH: 'Last month',
    THREE_MONTHS: 'last 3 months',
    HALF_A_YEAR: 'last 6 months',
    piece: 'Pieces',

    message: 'Transfer instructions',
    bankName: 'Bank name',
    KTbank: 'Kasikron Bank',
    bankAccounts: 'Bank account',
    payeeName: 'Payee Name',
    remark: 'Remark',
    operatingProcedures: 'Operating procedures',
    remark1: '1. By recommended bank transfer to our bank account;',
    remark2: '2. Log in to the APP, submit an application and upload evidence;',
    remark3: '3. The staff will complete the review within 2 working days.',
    precautions: 'Precautions',
    precautionsRemark1: '1. In order to ensure that your review is successful, please carefully check payment information is filled in correctly',
    precautionsRemark2: '2. Please be sure to fill your station code in the money transfer remark: so we can check your remittance information',
    fundsTotal: 'Total funds',
    formula: 'Total capital = balance of advance payment + operating income',
    prepayment: 'prepayment',
    prepaymentRemarks1: '(1) At present, only offline remittance recharge is supported',
    prepaymentRemarks2: '(2) The advance payment can be used for "printing face sheet"; In the future, prepayment can be used for purchase',
    prepaymentRemarks3: "(3) Advance payment can't be withdrawn or refunded!!!",

    dayViewName: 'Daily view',
    weightViewName: 'Weight view',
    dayViewLeftTabName: 'Outbound quantity',
    dayViewRightTabName: 'Delivery fee',
    dayViewTableCol1Name: 'Date',
    dayViewTableCol2Name: 'Outbound quantity',
    dayViewTableCol3Name: 'Delivery fee（฿）',
    dayViewTableNullData: 'No data',
    dayViewDataTotalLeft: 'Outbound quantity（piece）',
    dayViewDataTotalRight: 'Delivery fee（฿）',
    weightViewPieDataTotal: 'Outbound quantity',
    weightViewTableCol1Name: 'Kilogram',
    weightViewTableCol2Name: 'Percentage',
    weightViewTableCol3Name: 'Quantity/Fee（฿）',
    weightViewTableNullData: 'No data',
    weightViewDetailTableCol1Name: 'Waybill no.',
    weightViewDetailTableCol2Name: 'Calc Weight（kg）',
    weightViewDetailTableCol3Name: 'Delivery fee（฿）',
    weightViewDetailTableNullData: 'No data',
    weightViewDetailDataTotalLeft: 'Outbound quantity（piece）',
    weightViewDetailDataTotalRight: 'Delivery fee（฿）',
    dataSelectTitle: 'Select time',
    dataSelectTimeConnectText: '-',
    dataSelectConfirmText: 'Confirm',
    dataSelectCancelText: 'Cancel',
    idcard1: 'For safety reasons and requirements according to Thai law The sender must attach a personal identification document (such as an ID card or passport) to our staff in order to record the shipment information.',
    idcard2: 'upload files',
    idcard3: 'Real name',
    idcard4: 'Identification Number',
    idcard5: 'Please upload pictures in jpg, jpeg, png format',
    idcard6: 'The upload image size cannot exceed 10MB!',
    idcard7: 'Uploading',
    idcard8: 'Upload successful',
    idcard9: 'Please upload documents first',
    idcard10: 'ID number cannot be empty',
    idcard11: 'Name cannot be empty',
    idcard12: 'Authentication succeeded',
    idcard13: 'Upload failed',
    idcard14: 'Please enter a 13 digits Thai ID card',
    idcard15: 'It looks like we are missing a page!',
    idcard16: 'Type of certificate',
    idcard17: 'ID card',
    idcard18: 'PASSPORT',
    idcard19: 'Passport Name',
    idcard20: 'Passport no.',
    idcard21: 'Passport number length is 1-30 digits',
    stayBackQuantity: 'Return pending',
    zhi: 'To',
    detail: 'Details',
    dateSelect: 'Query date',
    CODConfirmText: 'Confirm handover',
    package: 'COD package',
    amount: 'COD amount',
    outbound: 'COD outbound details',
    confirmed: 'confirmed',
    unconfirmed: 'unconfirmed',
    outboundTime: 'Outbound time',
    courierSignature: 'Courier Signature',
    sign: 'Sign',
    clear: 'Clear',
    submit: 'Submit',
    waybillNo: 'Waybill no.',
    codRecord: 'handover record',
    Total: 'Total',
    CreateHandover: 'Create a handover'
  }
}
export default en



// WEBPACK FOOTER //
// ./src/i18n/language/en.js